import { Component, OnInit } from '@angular/core';
import { RoutesRecognized , Router } from '@angular/router';
import { AppAvailability } from '@ionic-native/app-availability/ngx';
import { Platform } from '@ionic/angular';
import { WebIntent } from '@ionic-native/web-intent/ngx';
import { PaymentService } from '../payment.service';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { filter, pairwise } from 'rxjs/operators';


@Component({
  selector: 'app-payment-options',
  templateUrl: './payment-options.component.html',
  styleUrls: ['./payment-options.component.scss'],
})
export class PaymentOptionsComponent  {
  purrchaseItems:any;
  contactNbrMob;
  payTotal;
  cosiValue;
  type;
  requestorId;
  cost;
url;
subs:boolean=false;
paynow:boolean=true;
value;
paytmPay:boolean=true;
previousUrl: string;
popSer:boolean=false;

  constructor(private router:Router, private service: ApiService,public handler: HandlerService, public payment:PaymentService,private appAvailability: AppAvailability,private platform: Platform,
    private intent:WebIntent) {
     }
  id;loader:boolean=false;
      upiopts=[
  // {id:1,value:6,name:"GPAY",img:"assets/icon/Google-Pay.png",appId:"com.google.android.apps.nbu.paisa.user",grey:true},
  {id:2,value:7,name:"PHONEPE",img:"assets/icon/phone-pe.png",appId:"com.phonepe.app",grey:false},
  {id:3,value:8,name:"PAYTM",img:"assets/icon/paytm.png",appId:"net.one97.paytm",grey:false}]

  array=[{id:1,name:"mconnectz"}] 

  ionViewWillEnter() {

    this.paytmPay = true;   
    this.handler.loader=true;
    this.url= window.location.href;
    if(this.url.includes('order-payment')){
      this.id = localStorage.getItem('updateOrderId');
    }else{
      this.id = this.url.split('/').pop();
    }
   this.cost = sessionStorage.getItem('PayCost')
   this.upiopts.map((res,i)=>{
     this.appAvailability.check(res.appId).then(res=>{
     },err=>{
       this.upiopts=this.upiopts.filter(res1=>res.id!=res1.id)
     })
     if(i==this.upiopts.length-1)
     this.loader=false;
   })
   if(this.url.includes('payment-subs') ||this.url.includes('orders-pay-options')  ){
     this.paynow = false;
   }
   if(this.url.includes('sub-pay') || this.url.includes('payment-subs')){
     this.subs = true;
    this.getSubscription();  
  }else{
    this.subs = false;
    this.getRequest();  
  }
 
  }

  clear(){
    this.payment.paytmPopUp = false;
  }
  
  pay(data,i){
    this.upiopts[i].grey = true;
    console.log(this.upiopts)
    this.value=data.value;
    // this.modeId = data.value;
    if(data.id==1){
      const url = 'upi://pay?pa=mail2priya.gc@okhdfcbank&pn=mail2priya.gc@okhdfcbank&tr=ORDER123&tn=Test Payment&am=1&cu=INR';
      const options = {
        action: this.intent.ACTION_VIEW,
        url,
        package:data.appId
      };
      
    this.intent.startActivityForResult(options).then((onSuccess:any)=>{
      this.handler.loader = true;
      console.log(onSuccess,'check')
      if(onSuccess.extras.Status=="Success" || onSuccess.extras.Status=="SUCCESS" || onSuccess.extras.Status=="success"){
       this.handler.staticError("Payment failed.Order has not been Placed.Try another method");
       this.handler.loader = false;
     }else{
      if(this.url.includes('sub-pay')|| this.url.includes('payment-subs')){
            var post ={
            cost: sessionStorage.getItem('PayCost'),
            paymentMode: this.value,      
            paymentRcvdBy:'23874' ,  
            month:sessionStorage.getItem('month'),
            year:sessionStorage.getItem('year'),      
            referenceId:onSuccess.extras.bleTxId
          }        
        this.service.postSubsPaymentDetails(this.id,post).subscribe(res1=>{
          this.handler.res("Payment is successfull!!! Please wait to be redirected to app automatically... ");
          this.router.navigate(['/bookservice1']);
        }, err => {
          this.handler.loader = false;
        })
      }else{
         var post1 ={
          paymtAmt: sessionStorage.getItem('PayCost'),
          paymtMode:this.value,
          paymtRef:onSuccess.extras.bleTxId
        }     
        this.service.postOrderPaymentDetails(this.id,post1).subscribe(res1=>{
         
          this.handler.res("Payment is successfull!!! Please wait to be redirected to app automatically... ");
          this.complete();    
        }, err => {
          this.handler.loader = false;
        })  
      }
     }
  },
  onError=>{
    this.handler.err(onError) 
    this.handler.loader=false;    
       this.router.navigate(['/bookservice1'])    
    })
    }
    if(data.id==2 || data.id==3){
      const url = 'upi://pay?pa=9159599595@okbizaxis&pn=Yessboss&tr='+this.id+'&tn=Test Payment&am='+this.cosiValue+'&cu=INR';
      const options = {
        action: this.intent.ACTION_VIEW,
        url,
        package:data.appId
      };
    this.intent.startActivityForResult(options).then((onSuccess:any)=>{
      this.handler.loader=true;
      console.log(onSuccess,'check')
       if(onSuccess.extras.Status=="Success" || onSuccess.extras.Status=="SUCCESS" || onSuccess.extras.Status=="success"){
        if(this.url.includes('sub-pay')|| this.url.includes('payment-subs')){
          var post ={
           cost: sessionStorage.getItem('PayCost'),
           paymentMode: this.value,      
           paymentRcvdBy:'23874' ,  
           paymentStatus:2, 
           month:sessionStorage.getItem('month'),
           year:sessionStorage.getItem('year'),      
           referenceId:onSuccess.extras.bleTxId
         }        
       this.service.postSubsPaymentDetails(this.id,post).subscribe(res1=>{
         this.handler.res("Payment is successfull!!! Please wait to be redirected to app automatically... ");
         this.handler.payObj=onSuccess.extras;
         this.handler.amount=sessionStorage.getItem('PayCost');
         this.router.navigate(['/PASS']);
       }, err => {
        this.handler.loader = false;
      })
     }else{
       var post1 ={
         PaymtAmt: sessionStorage.getItem('PayCost'),
         PaymtMode:this.value,
         PaymtRef:onSuccess.extras.bleTxId,
         paymtStatus:2
       }     
       this.service.postOrderPaymentDetails(this.id,post1).subscribe(res1=>{
         this.handler.res("Payment is successfull!!! Please wait to be redirected to app automatically... ");
         this.upiComplete();  
         this.handler.payObj=onSuccess.extras;
         this.handler.amount=sessionStorage.getItem('PayCost');
         this.router.navigate(['/PASS']);  
       }, err => {
        this.handler.loader = false;
      })  
     }
     }else{
      this.handler.staticError("Payment failed.Order has not been Placed.Try another method");
      this.handler.loader=false; 
      this.handler.payObj=onSuccess.extras;
      this.handler.amount=sessionStorage.getItem('PayCost');
      this.router.navigate(['/FAIL']);
     }

  },
   onError=>{
    this.handler.err(onError);
    this.handler.loader=false;        
      this.router.navigate(['/bookservice1'])    
    })
    }
  
  }

  getSubscription(){
    this.service.getCustItemSubsById(this.id).subscribe((res:any)=>{
      if(res){
        this.purrchaseItems = res;    
     
        }
        if(this.url.includes('3.209.13.42')){
          this.payment.setPaymentParamters(this.purrchaseItems,1)       
         }else{
          this.payment.setPaymentParamters(this.purrchaseItems,2)     
         }
         this.handler.loader = false;  
    },
      err => {
        this.handler.loader = false;
        this.handler.err(err.error)
      })
  }
  
  getRequest(){
    this.service.getOrderById(this.id).subscribe((res:any) => {
      if (res) {
       this.purrchaseItems = res;
       if(res.status==1){
         sessionStorage.setItem('handler',"true")
       }
       this.type = res.orderType;
       if(this.purrchaseItems.paymtStatus==3&&this.purrchaseItems.amountYetToBePaidStr){
        Object.assign(this.purrchaseItems,{requestorId:res.customerId,payTotal:res.amountYetToBePaidStr,contactNbrMob:res.customer?.contactNbrMob})
       }else{
       Object.assign(this.purrchaseItems,{requestorId:res.customerId,payTotal:res.orderAmountStr,contactNbrMob:res.customer?.contactNbrMob})
       }
      }
      if(this.purrchaseItems.paymtStatus==3&&this.purrchaseItems.amountYetToBePaidStr){
        this.cosiValue=this.purrchaseItems.amountYetToBePaidStr;
      }else{
        this.cosiValue=this.purrchaseItems.orderAmountStr;
      }
      if(window['url'].includes('3.209.13.42')){
        this.payment.setPaymentParamters(this.purrchaseItems,1)   
       }else{
        this.payment.setPaymentParamters(this.purrchaseItems,2)
        console.log(this.purrchaseItems,"order-payment")  
       }
       this.handler.loader = false; 
     },
      err => {
        this.handler.loader = false; 
        this.handler.err(err.error)
      })
  }


  upiComplete() { 
    this.handler.loader=true; 
    if(this.type==1){
        var post={
          orderType:1
        }
      } else{
          var post={
            orderType:2
          } 
        }
        this.service.completeOrder(this.id,post).subscribe(res => {
          this.handler.res("Order Placed SuccessFully"); 
          if(localStorage.getItem('orderId')==localStorage.getItem('updateOrderId')){
            localStorage.removeItem('orderId');
            localStorage.removeItem('cateId'); 
            sessionStorage.removeItem('orderValue')
          }  
          this.handler.loader=false; 
        },
          err => {  
            this.handler.loader=false; 
            this.handler.err(err);     
          })
        }

 startPaytm(){
  if(this.paytmPay){
    this.paytmPay = false;
  }
  this.payment.paytmm();
 }

  
  complete() { 
    // this.handler.loader=true; 
    this.popSer = true;
    if(!this.url.includes('orders-pay-options')){
      if(this.type==1){
        var post={
          orderType:1
        }
      } else{
          var post={
            orderType:2
          } 
        }
        this.service.completeOrder(this.id,post).subscribe(res => {
          this.handler.res("Order Placed SuccessFully");
          if(localStorage.getItem('orderId')==localStorage.getItem('updateOrderId')){
            localStorage.removeItem('orderId');
            localStorage.removeItem('cateId');
            sessionStorage.removeItem('orderValue')
          }        
          this.router.navigate(['/bookservice1'])
          this.handler.loader=false; 
        },
          err => {  
            this.handler.loader=false; 
            this.handler.err(err);     
          })
         }
        }
  

  completeSubs(){
    this.handler.loader = true;
    if(!this.url.includes('payment-subs')){
    var post ={
      cost: sessionStorage.getItem('PayCost'),
      paymentMode: 1,      
      paymentRcvdBy:'23874' ,  
      month:sessionStorage.getItem('month'),
      year:sessionStorage.getItem('year'),  
      paymentStatus:1, 
      
    
    }        
  this.service.postSubsPaymentDetails(this.id,post).subscribe(res1=>{ 
    this.handler.res("Payment is successfull!!! Please wait to be redirected to app automatically... ");
    this.router.navigate(['/bookservice1']);
  })
}
  }

  popFunction(){
    this.popSer=true;
  
  }
  close(){
    this.popSer=false;
  }

  closePop()
  {
    this.popSer=false;
  }
}
